import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import { useTextblocksCatalogDeleteMutation } from "@/services/backend/textblocks/api/catalog-api";
import { useEffect, useState } from "react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Catalog } from "@/services/backend/textblocks/types/catalog";

interface Props {
  catalog: Catalog;
  onDeleted: () => void;
}

export function DeleteCatalogsDialog({ catalog, onDeleted }: Props) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error, isSuccess, reset }] =
    useTextblocksCatalogDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
      onDeleted();
    }
  }, [isSuccess, onDeleted, reset]);

  const doDelete = () => {
    if (isLoading) return;

    del({ id: catalog.id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive">
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Katalog löschen")}</DialogTitle>
          <DialogDescription>
            {t(`Möchten Sie den Katalog ${catalog.name} löschen?`)}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter
          isLoading={false}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
